import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import Footer from "../../components/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { handleScreenWidth } from "../../redux/layout";
import MenuBar from "../../components/menuBar/MenuBar";
import FullScreenLoader from "../../components/FullScreenLoader";

const Layout = () => {
  const [isMenuBar, setIsMenuBar] = useState(false);
  const dispatch = useDispatch();
  const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
  const isLoader = useSelector((state: any) => state.layout.isLoader);

  useEffect(() => {
    window.addEventListener("resize", () => { dispatch(handleScreenWidth(window.innerWidth)) });
    return () => {
      window.removeEventListener("resize", () => { dispatch(handleScreenWidth(window.innerWidth)) });
    };
  }, [screenWidth, dispatch]);

  return (
    <>
      <div>
        <Header setIsMenuBar={setIsMenuBar} />
        <MenuBar isMenuBar={isMenuBar} setIsMenuBar={setIsMenuBar} />
        <Container className="mt-3" style={{ marginBottom: "70px" }}>
          <Outlet />
          <Footer />
        </Container>
      </div>
      {isLoader && <FullScreenLoader />}
    </>
  );
};

export default Layout;
